import React from 'react';
import axios from 'axios';
import { Table, Confirm, Button, ButtonGroup } from 'semantic-ui-react';
import { NoData } from "../../components/table/no-data";
import FormattedDate from "../../components/formatters/formattedDate";
import { apiUrl } from "../../config.js"
import { AuthService } from '../../services/auth-service'


class UserGuideTableRow extends React.Component {

    constructor(props) {
        super(props);

        this.authServices = new AuthService();

        this.state = {
            open: false, result: 'show the modal to capture a result',
            isReadOnly : this.authServices.isReadOnly(),
            isAdmin: false, // Default to false until the check is complete
        }

    

    }

    
    componentDidMount() {
          
        this.checkAdminStatus();
    }
    
    checkAdminStatus = async () => {
        const isAdmin = await this.authServices.isUserAdmin();
        this.setState({ isAdmin });
    };

  //  state = { }

    show = () => this.setState({ open: true })
    handleConfirm = (documentID) => {
        this.setState({ result: 'confirmed', open: false })
        const authService = new AuthService();

        const formData = new FormData();
        formData.append("documentid", documentID);
        formData.append("deletedBy", authService.getUserData(AuthService.EMAIL_KEY));
        const request = new XMLHttpRequest();

        request.open('POST', `${apiUrl}/Documents/DeleteDocument`);
        request.setRequestHeader(
            'Authorization', `bearer ${localStorage.getItem("token")}`);

        request.onload = (e) => {
            if (request.status >= 200 && request.status < 300) {
                window.location.reload();
            }
            else {
                //error('failed upload');
            }
        };
        request.send(formData);   
    }

    handleCancel = () => this.setState({ result: 'cancelled', open: false })

    downloadDocument = (documentID,name,ext) => {
         
        axios({
            url: `${apiUrl}/Documents/DownloadDocument/${documentID}`,
            method: 'POST',       // Worked using POST or PUT. Prefer POST
            headers : {
                'Authorization': `bearer ${localStorage.getItem("token")}`
             },
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name + '' + ext);
            document.body.appendChild(link);
            link.click();
          });
    }

    render() {
        const { open } = this.state

        return (
            <Table.Row>
                <Table.Cell>{this.props.data.documentName || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.documentExt || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.uploadedBy || <NoData />}</Table.Cell>
                <Table.Cell><FormattedDate value={this.props.data.dateCreated} /></Table.Cell>

                <Table.Cell>
                    <ButtonGroup floated='right'>
                    {this.state.isAdmin  === true &&
                        <Button onClick={this.show} icon='trash' color='red'></Button>
                    }
                        <Confirm
                            open={open}
                            onCancel={this.handleCancel}
                            onConfirm={() => this.handleConfirm(this.props.data.documentid)}
                        />
                        <Button icon='download'onClick={() => this.downloadDocument(this.props.data.documentid,this.props.data.documentName,this.props.data.documentExt)}  color='green'></Button>

                    </ButtonGroup>
                </Table.Cell>
            </Table.Row>
        );
    }
}

export default UserGuideTableRow;